/**
 * Copyright 2022-2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { ResourceExecutionStatus } from "~/generated/graphql";

/**
 * Set of statuses that indicate a successful resource execution
 */
export const SUCCESS_STATUSES = new Set([
  ResourceExecutionStatus.Success,
  ResourceExecutionStatus.ManualSuccess,
]);

/**
 * Set of statuses that indicate an unsuccessful resource execution
 */
export const UNSUCCESS_STATUSES = new Set([
  ResourceExecutionStatus.Failed,
  ResourceExecutionStatus.Timeout,
  ResourceExecutionStatus.NotInTimeWindow,
  ResourceExecutionStatus.Error,
]);

/**
 * Set of statuses that indicate a resource execution is not yet completed
 */
export const NOT_COMPLETED_STATUSES = new Set([
  ResourceExecutionStatus.Pending,
  ResourceExecutionStatus.InProgress,
]);
